import Translator from "@/utils/common/Translator.ts";
import {Dialog} from "quasar";
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import NamaDialogBox from "@/components/dialogs/NamaDialogBox.vue";
import DialogButtons from "@/utils/forms/DialogButtons.ts";
import EditViewPerformer from "@/utils/presenters/EditViewPerformer.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import QuestionField = namaTypes.QuestionField;
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;

export default class DialogHandler {
  title?: string;
  actions: CommonDialogAction[];
  presenter?: QuestionFieldsPresenter;
  closeAction?: Function;
  singleColumnGroup?: boolean;
  alwaysAllowed?:boolean;


  constructor(actions: CommonDialogAction[], title?: string, singleColumnGroup?: boolean, closeAction?: Function) {
    this.title = title;
    this.actions = actions;
    this.singleColumnGroup = singleColumnGroup;
    this.closeAction = closeAction;
  }

  async createPresenter(presenter: WidgetsPresenter, questionFields?: QuestionField[], defaultFields?: DTOFilledQuestionField[]) {
    this.presenter = await this.createQuestionFieldPresenterIfNeeded(presenter, questionFields, defaultFields);
  }

  private async createQuestionFieldPresenterIfNeeded(presenter: WidgetsPresenter, questionFields: QuestionField[] | undefined, defaultFields?: DTOFilledQuestionField[]): Promise<QuestionFieldsPresenter> {
    if (presenter instanceof QuestionFieldsPresenter) {
      return presenter as QuestionFieldsPresenter;
    } else {
      let questionPresenter: QuestionFieldsPresenter = new QuestionFieldsPresenter(presenter.entityType);
      if (presenter instanceof EditPresenter)
        questionPresenter.performer = new EditViewPerformer(presenter);
      await questionPresenter.edit(questionFields ?? [], defaultFields ?? []);
      return questionPresenter;
    }
  }

  async runDialogBox() {
    return new Promise((resolve) => {
      Dialog.create({
        component: NamaDialogBox,
        componentProps: {
          handler: this
        }
      }).onDismiss(() => resolve(''))
    });
  }
}

export class CommonDialogAction {
  id: string;
  title: string;
  action?: Function;
  doNotCloseDialog: boolean;

  constructor(id: string, action?: Function, doNotCloseDialog?: boolean) {
    this.id = id;
    this.title = Translator.translateId(id);
    this.action = action;
    this.doNotCloseDialog = doNotCloseDialog ?? false;
    if (!action)
      this.action = this.fetchBasicDialogAction();
  }

  fetchBasicDialogAction() {
    switch (this.id) {
      case DialogButtons.Ok:
      case DialogButtons.Cancel:
      case DialogButtons.Close:
      case DialogButtons.Yes:
      case DialogButtons.No:
      default:
        return () => {
          console.log(this.id + " clicked");
        }
    }
  }

  static createOkDialogAction(action?: Function) {
    return new CommonDialogAction(DialogButtons.Ok, action);
  }

  static createCancelDialogAction(action?: Function) {
    return new CommonDialogAction(DialogButtons.Cancel, action);
  }

  static createCloseDialogAction(action?: Function) {
    return new CommonDialogAction(DialogButtons.Close, action);
  }

  static createYesDialogAction(action?: Function) {
    return new CommonDialogAction(DialogButtons.Yes, action);
  }

  static createNoDialogAction(action?: Function) {
    return new CommonDialogAction(DialogButtons.No, action);
  }
}
